<template>
    <el-cascader
        v-model="val"
        :options="cascadeOptions"
        :props="cascaderProps"
        @change="handleChange"
        :placeholder="placeholder"
        :multiple="multiple"
        clearable
        filterable
    ></el-cascader>
</template>

<script>
import { getProductTypeList, getDeviceTypeList } from "@/api/device/list";
export default {
    props: {
        value: {
            type: Array | String | Number,
            default: "",
        },
        multiple: {
            type: Boolean,
            default: false
        },
        placeholder: {
            type: String,
            default: "请选择设备类型"
        }
    },
    data() {
        return {
            val: "",
            cascadeOptions: [],
            cascaderProps: {
                value: 'value',
                label: 'label',
                children: 'children',
                emitPath: true
            }
        };
    },
    watch: {
        value: {
            handler(val) {
                this.val = val;
            },
            immediate: true,
        },
    },
    mounted() {
        this.loadProductTypes();
    },
    methods: {
        async loadProductTypes() {
            try {
                // 先获取产品类型列表
                const { code, result, message } = await getProductTypeList();
                if (code !== 200) {
                    this.$message.error(message);
                    return;
                }

                const productTypes = result || [];
                
                // 为每个产品类型加载对应的设备类型
                const cascadeData = await Promise.all(
                    productTypes.map(async (productType) => {
                        try {
                            const { code, result, message } = await getDeviceTypeList({ productType });
                            if (code === 200) {
                                return {
                                    value: productType,
                                    label: productType,
                                    children: (result || []).map(deviceType => ({
                                        value: deviceType,
                                        label: deviceType
                                    }))
                                };
                            } else {
                                console.warn(`加载产品类型 ${productType} 的设备类型失败:`, message);
                                return {
                                    value: productType,
                                    label: productType,
                                    children: []
                                };
                            }
                        } catch (error) {
                            console.warn(`加载产品类型 ${productType} 的设备类型出错:`, error);
                            return {
                                value: productType,
                                label: productType,
                                children: []
                            };
                        }
                    })
                );

                this.cascadeOptions = cascadeData;
            } catch (error) {
                this.$message.error('加载数据失败');
                console.error('加载级联数据出错:', error);
            }
        },
        handleChange(val) {
            console.log(val);
            this.$emit("input", val);
            this.$emit("change", val);
        },
    },
};
</script>

<style></style>
